module.exports = {
  "grid-select": {
    "flexDirection": "row",
    "justifyContent": "space-between",
    "flexWrap": "wrap"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-5dabbea7!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-grid-select/index.vue
// module id = 176
// module chunks = 0 1